import { render, staticRenderFns } from "./CollectivesGlobalSettings.vue?vue&type=template&id=b991409a"
import script from "./CollectivesGlobalSettings.vue?vue&type=script&lang=js"
export * from "./CollectivesGlobalSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports